import React from 'react';

import { useQuery } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import * as PropTypes from 'prop-types';

import Loading from '../Loading/Loading';
import Toast from '../Toast/Toast';

function handleError(error) {
  console.error(error);

  return <Toast error="Une erreur s'est produite" icon={true} />;
}

function QueryWrapper({ loading: loader, query = null, variables = {}, children, ...otherProps }) {
  return (
    <Query query={query} variables={variables} {...otherProps}>
      {({ loading, error, data }) => {
        if (loading) return loader;
        if (error) return handleError(error);

        return children({ data });
      }}
    </Query>
  );
}

export function useQueryWrapper(query, variables, options) {
  const { loading, error, data } = useQuery(query, { variables, ...options });
  if (loading) return <Loading type={Loading.TYPE.MATERIAL} name={'linear'} />;
  if (error) return handleError(error);

  return data;
}

QueryWrapper.propTypes = {
  query: PropTypes.object,
  variables: PropTypes.object,
  loading: PropTypes.any,
};

QueryWrapper.defaultProps = {
  query: null,
  variables: {},
  loading: <Loading type={Loading.TYPE.MATERIAL} name={'linear'} />,
};

export default QueryWrapper;
